import { Fragment } from 'react';
import moment from 'moment';

import { SmartTableCellProps } from '@/components/ui/daisy';

import { ScheduledLessonWithKlass } from '../types';

export default function DateCell({
  item,
}: SmartTableCellProps<ScheduledLessonWithKlass>) {
  return (
    <Fragment>{moment(item.datetime).format('DD/MM/YY - HH:mm')}</Fragment>
  );
}
